import { useEffect, useState } from "react";
import { whoami } from "../services/APIClient";

const useHandoverIdentity = () => {
  const [identity, setIdentity] = useState(null);
  const [identityStatus, setIdentityStatus] = useState("loading");

  useEffect(() => {
    whoami()
      .then((response) => {
        setIdentity(response?.data?.stakeholder || null);
        setIdentityStatus("ready");
      })
      .catch(() => setIdentityStatus("error"));
  }, []);

  return { identity, identityStatus };
};

export default useHandoverIdentity;
